module.exports = __webpack_public_path__ + "media/images/front/programs/icon-plus-06efe594c7064c2aad756e845b59b51d.svg";